import styled from "@yb/styled-px2rem";
import SpriteImage from "@PUBLIC/M/images/ico/ico_spr.png";
import EventImage from "@PUBLIC/M/images/content/event/yellowpangdeal/img_yellow_sprite.png";
import LiveImage from "@PUBLIC/M/images/content/event/yellowlive/img_live_sprite.png";

const ContentWrap = styled.div``;

const ContentTop = styled.div`
	padding: 15px 15px 30px;
`;

const SummaryInfo = styled.div`
	display: flex;
	margin-bottom: 15px;
	align-items: center;
	justify-content: end;
	gap: 15px;
`;

const ScoreText = styled.span`
	display: flex;
	align-items: center;
	font-size: var(--small-size);

	em {
		margin-right: 3px;
		color: var(--red-color);
	}
`;

const StarImg = styled.i`
	display: inline-block;
	width: 14px;
	height: 14px;
	background: url(${SpriteImage}) 0px -160px / 300px 300px no-repeat;
`;

const TopTitle = styled.h4`
	margin-top: 15px;
	font-weight: bold;
	font-size: 21px;
	color: var(--emp-color);
`;

const TopPriceBox = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: 8px;
	gap: 5px;

	> span {
		font-weight: bold;
	}
	em {
		font-size: var(--medium-size);
		font-weight: bold;
	}
`;

const TopPriceDate = styled.span`
	font-size: var(--small-size);
`;

const EventBannerWrap = styled.div`
	display: flex;
	padding: 0 15px 30px;
	flex-direction: column;
	gap: 10px;

	a {
		display: flex;
		justify-content: center;
	}
`;

const EventBanner = styled.div`
	img {
		max-width: 100%;
		min-height: 100%;
		width: 100%;
		vertical-align: top;
	}

	@media (max-width: 340px) {
		margin-left: -15px;
		margin-right: -15px;
	}
`;

const PangdealPrice = styled.div`
	position: relative;
	display: flex;
	height: 50px;
	padding: 0 13px 0 95px;
	background-color: #ffde2f;
	flex: 1 auto;
	align-items: center;
	flex-shrink: 0;
	overflow: hidden;

	&:before {
		position: absolute;
		top: 50%;
		left: 20px;
		display: block;
		width: 75px;
		height: 37px;
		background: url(${EventImage}) 0px 0px / 200px 200px no-repeat;
		transform: translateY(-50%);
		content: "";
	}

	@media all and (min-width: 340px) and (max-width: 355px) {
		padding: 0 0 0 84px;
		flex-shrink: initial;
	}
`;

const PriceBox = styled.div`
	display: flex;
	padding-left: 6px;
	font-size: var(--basic-size);
	color: var(--emp-color);
	line-height: 1;
	flex-direction: column;
	gap: 3px;

	&:after {
		position: absolute;
		top: 0;
		right: 0;
		display: block;
		width: 0;
		height: 0;
		border-top: 25px solid var(--yellow-color);
		border-bottom: 25px solid var(--yellow-color);
		border-left: 13px solid #ffde2f;
		content: "";
	}
`;

const PangdealProduct = styled.span`
	color: var(--red-color);
`;

const PangdealDate = styled.span`
	color: var(--blue-color);
`;

const PangdealLink = styled.div`
	display: flex;
	height: 50px;
	padding: 0 15px 0 10px;
	background-color: var(--yellow-color);
	font-size: var(--small-size);
	color: var(--emp-color);
	line-height: 1.1;
	align-items: center;
	flex-shrink: 0;

	span {
		position: relative;
		padding-right: 9px;
		line-height: 1;

		&:after {
			position: absolute;
			right: 0;
			top: 3px;
			display: inline-block;
			width: 4px;
			height: 4px;
			border-top: 1px solid #020202;
			border-right: 1px solid #020202;
			transform: rotate(45deg);
			content: "";
		}
	}
`;

const BannerYellowLive = styled.div`
	position: relative;
	display: flex;
	height: 50px;
	padding-left: 100px;
	background-color: #ff9574;
	overflow: hidden;

	&:before {
		position: absolute;
		top: 0;
		left: 0;
		display: block;
		width: 100%;
		height: 50px;
		background: url(${LiveImage}) 0px -39px/ 300px 300px no-repeat;
		content: "";
	}
	&::after {
		position: absolute;
		right: 0;
		bottom: 0;
		display: block;
		width: 39px;
		height: 39px;
		background: url(${LiveImage}) 0px 0px/ 300px 300px no-repeat;
		content: "";
	}
	a {
		display: flex;
		z-index: 1;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		height: 100%;
	}

	@media (max-width: 340px) {
		margin-left: -15px;
		margin-right: -15px;
	}
`;

const LiveText = styled.p`
	display: flex;
	flex-direction: column;
	white-space: nowrap;
	gap: 5px;
	flex: 1 1 100%;
	font-size: var(--small-size);

	> div {
		line-height: 1;
	}
`;

const LiveTit = styled.span`
	line-height: 1;
	color: #fff;
`;
const LiveDate = styled.span`
	line-height: 1;
	margin-right: 5px;
	color: var(--emp-color);
	font-family: "PT-bold";
`;
const LiveState = styled.span`
	line-height: 1;
	color: #fff;
	font-family: "PT-medium";
`;

const LiveLink = styled.div`
	display: flex;
	align-items: center;
	justify-content: end;
	flex: 0 0 23px;
	> span {
		position: relative;
		font-size: 0;
		line-height: 1;

		&:after {
			position: absolute;
			top: 50%;
			right: 15px;
			display: inline-block;
			width: 10px;
			height: 10px;
			border-top: 2px solid #020202;
			border-right: 2px solid #020202;
			transform: translateY(-50%) rotate(45deg);
			content: "";
		}
	}
`;

const ResetButton = styled.button`
	position: relative;
	padding-left: 25px;
	padding-right: 16px;
	margin-right: 15px;
	font-size: var(--default-size);
	color: var(--default-color);
	flex-shrink: 0;

	&:before {
		position: absolute;
		left: 0;
		top: 50%;
		display: block;
		width: 15px;
		height: 15px;
		background: url(${SpriteImage}) -135px 0px / 300px 300px no-repeat;
		transform: translateY(-50%);
		content: "";
	}

	&:after {
		position: absolute;
		right: 0;
		top: 50%;
		width: 1px;
		height: 13px;
		background-color: var(--line-color);
		transform: translateY(-50%);
		content: "";
	}
`;

const FilterCheckWrap = styled.ul`
	display: flex;
	padding: 7px 15px;
	border-top: 1px solid var(--line-color);
	gap: 5px;
`;

const FilterCheck = styled.li`
	position: relative;

	input {
		position: absolute;
		top: 0;
		left: 0;
		width: 1px;
		height: 1px;
		padding: 0;
		margin: 0;
		background-color: transparent;
		border: 0;

		&:checked {
			+ label {
				background-color: var(--yellow-color);
				color: var(--emp-color);
			}
		}

		+ label {
			display: inline-block;
			width: 100%;
			padding: 9px 15px;
			border: 1px solid var(--line-color);
			border-radius: 30px;
			background-color: #fff;
			line-height: 1;
			box-sizing: border-box;
			overflow: hidden;
			vertical-align: top;
		}

		@media (max-width: 390px) {
			+ label {
				padding: 9px 12px;
			}
		}
	}

	@media (max-width: 390px) {
		button {
			padding: 9px 10px;
		}
	}
`;

const FilterButton = styled.button`
	display: inline-block;
	width: 100%;
	padding: 9px 15px;
	border: 1px solid var(--line-color);
	border-radius: 30px;
	background-color: #fff;
	font-size: var(--default-size);
	line-height: 1;
	box-sizing: border-box;
	overflow: hidden;
	vertical-align: top;

	em {
		position: relative;
		display: block;
		padding-right: 13px;
		color: var(--default-color);

		&:after {
			position: absolute;
			top: 2px;
			right: 0;
			display: block;
			width: 5px;
			height: 5px;
			border-top: 1px solid var(--emp-color);
			border-right: 1px solid var(--emp-color);
			font-size: 0px;
			transform: rotate(135deg);
			content: "";
		}
	}
`;

const TitleWrap = styled.div`
	display: flex;
	height: 50px;
	padding: 0 15px;
	border-bottom: 1px solid var(--line-color);
	font-size: var(--medium-size);
	align-items: center;

	select {
		height: 100%;
		font-size: var(--default-size);
	}
`;

const ReservationBox = styled.div`
	display: flex;
	flex-shrink: 0;
	gap: 14px;
`;

const ReservationText = styled.span<{state: string}>`
	display: flex;
	font-size: var(--small-size);
	color: var(--emp-color);
	align-items: center;
	gap: 5px;

	&:before {
		display: inline-block;
		width: 10px;
		height: 10px;
		background-color: ${props => {
			if (props.state === "possible") {
				return `
				var(--yellow-color);
			`;
			}
			if (props.state === "waiting") {
				return `
				#bfd1f5;
			`;
			}
			if (props.state === "deadline") {
				return `
				var(--line-color);
			`;
			}
		}};
		content: "";
	}
`;

const ProductList = styled.ul``;

const ProductItem = styled.li`
	padding: 30px 15px;
	border-bottom: 1px solid var(--line-color);
`;

const AirlineBox = styled.div`
	display: flex;
	margin-bottom: 15px;
	justify-content: space-between;

	> span {
		display: flex;
		align-items: center;
		gap: 5px;
	}
	img {
		width: 15px;
		height: 15px;
	}
`;

const Date = styled.div`
	display: flex;
	margin-bottom: 10px;

	span {
		line-height: 1;
	}

	span:first-child:after {
		display: inline-block;
		margin: 0 15px;
		width: 1px;
		height: 13px;
		background-color: var(--line-color);
		content: "";
	}
`;

const ProductTitle = styled.p`
	font-size: 17px;
	font-weight: bold;
	line-height: 1.41;
`;

const PromotionOption = styled.p`
	margin-top: 7px;
	font-size: var(--basic-size);
	color: var(--gray-color);

	span {
		margin-right: 5px;
		color: var(--default-color);
	}
`;

const ProductPriceBox = styled.div`
	display: flex;
	margin-top: 10px;
	justify-content: space-between;
	align-items: baseline;
	line-height: 1;
`;

const StatusText = styled.span`
	font-size: var(--small-size);

	span:first-child {
		margin-right: 5px;
	}
`;

const ReservationStatus = styled.span<{state: string}>`
	font-size: var(--default-size);
	font-weight: bold;
	color: ${props => {
		if (props.state === "possible") {
			return `
			#ffae00;
		`;
		}
		if (props.state === "waiting") {
			return `
			#a1baec;
		`;
		}
		if (props.state === "deadline") {
			return `
			#bbb;
		`;
		}
	}};
`;

const ProductPrice = styled.span`
	color: var(--red-color);

	em {
		font-size: var(--medium-size);
		font-weight: bold;
	}
`;

const ProcutNone = styled.div`
	display: flex;
	padding: 50px 0;
	border-bottom: 1px solid var(--line-color);
	background-color: var(--disabled-color);
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 9px;

	a {
		border-bottom: 1px solid var(--emp-color);
		color: var(--emp-color);
	}
`;

const CouponBox = styled.div`
	display: inline-flex;
	align-items: center;
	justify-content: end;
	gap: 9px;
	width: 100%;
	margin-top: 14px;
	em {
		color: var(--emp-color);
		line-height: 1;
	}
`;

const CouponIcon = styled.span`
	display: flex;
	height: 16px;

	i {
		display: flex;
		height: 100%;
		min-width: 30px;
		padding: 0 4px;
		margin-bottom: 1px;
		border-top: 1px solid #d6d6d6;
		border-bottom: 1px solid #d6d6d6;
		font-size: 10px;
		font-style: normal;
		color: var(--emp-color);
		align-items: center;
		justify-content: center;
	}

	&:before {
		display: block;
		width: 3px;
		height: 18px;
		background: url(${SpriteImage}) -75px -79px / 300px 300px;
		content: "";
	}

	&:after {
		display: block;
		width: 7px;
		height: 18px;
		background: url(${SpriteImage}) -80px -79px / 300px 300px;
		content: "";
	}
`;

export {
	ContentWrap,
	ContentTop,
	SummaryInfo,
	ScoreText,
	StarImg,
	TopTitle,
	TopPriceBox,
	TopPriceDate,
	EventBanner,
	PriceBox,
	PangdealPrice,
	PangdealProduct,
	PangdealDate,
	PangdealLink,
	EventBannerWrap,
	ResetButton,
	FilterCheckWrap,
	FilterCheck,
	FilterButton,
	TitleWrap,
	ReservationBox,
	ReservationText,
	ProductList,
	ProductItem,
	AirlineBox,
	Date,
	ProductTitle,
	PromotionOption,
	ProductPriceBox,
	StatusText,
	ReservationStatus,
	ProductPrice,
	ProcutNone,
	CouponBox,
	CouponIcon,
	BannerYellowLive,
	LiveDate,
	LiveLink,
	LiveState,
	LiveText,
	LiveTit,
};
